export const websiteData = [
    {
        title: "Pathfinders eSTEM HUB",
        description: "A platform that facilitates STEM learning for young learners.",
        image: "/images/p-stem-hub.png",
        url: "https://pathehub.randomwalktech.com"
    },
    {
        title: "Notebook BMS",
        description: "A platform for biomedical studies for Cameroonian students.",
        image: "/images/notebook-bms.png",
        url: "https://notebook-bms.randomwalktech.com/"
    },
    {
        title: "AICCO FINANCE",
        description: "Official website of Ayembe Investment Credit and Cooperative Organization",
        image: "/images/ayembe.png",
        url: "https://ayembeunion.org"
    },
    {
        title: "UEST TRAVELS",
        description: "Official website of Universal Education Services and Travels",
        image: "/images/uest.png",
        url: "https://uestravels.org/"
    },
    {
        title: "SCORM",
        description: "Official website of Solution Center for Outstanding Relationships and Marriages, C/o Mrs. Asanji Yvette.",
        image: "/images/scormay.png",
        url: "https://scormay.com"
    },
    {
        title: "MBECUDA GLOBAL",
        description: "Official website of MBEI Cultural and Development Association",
        image: "/images/mbecuda.png",
        url: "https://mbecuda-global.com"
    }
]